export enum BusinessRetirementPlan {
  BASIC = 'BASIC',
  IMPROVED = 'IMPROVED',
  CUSTOM = 'CUSTOM',
}

export const getBusinessRetirementPlanLabel = (
  plan: BusinessRetirementPlan
): string => {
  switch (plan) {
    case BusinessRetirementPlan.BASIC:
      return $localize`Basic`;
    case BusinessRetirementPlan.IMPROVED:
      return $localize`Amélioré`;
    case BusinessRetirementPlan.CUSTOM:
      return $localize`Personnalisé`;
    default:
      return plan;
  }
};
